import React, { useState } from "react";
import { IUser } from "../../models/user.ts";
import { FormControl, InputLabel, MenuItem, Select } from "@mui/material";

interface UserSelectProps {
  users: IUser[];
  onSelectedUsersChange: (selectedUserIds: number[]) => void;
}

export const UserSelect: React.FC<UserSelectProps> = ({
  users,
  onSelectedUsersChange: onSelectedUsersChange,
}) => {
  const [selectedUsers, setSelectedUsers] = useState<number[]>();
  if (users && users.length > 0) {
    return (
      <FormControl fullWidth variant="outlined">
        <InputLabel>担当者</InputLabel>
        <Select
          multiple
          value={selectedUsers || []}
          onChange={(event) => {
            const selectedIds = event.target.value as number[];
            setSelectedUsers(selectedIds);
            onSelectedUsersChange(selectedIds);
          }}
          label="担当者"
        >
          {users.map((user) => (
            <MenuItem key={user.id} value={user.id}>
              {user.name}
            </MenuItem>
          ))}
        </Select>
      </FormControl>
    );
  }
};
